import React, { useEffect, useState } from "react";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { format } from "date-fns";
import YearCalendar from "../../shared/YearlyCalendar";
import {
  SlInput,
  SlOption,
  SlSelect,
} from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import { useSelector } from "react-redux";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import { debounce } from "../../utils/Debounce";
import config from "../../config";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { getBrandOptions,toLakhs } from "../../utils/constants";
import TableSkelton from "../../shared/TableSkelton";
function BuildupSheet() {
  const [newsPapers, setNewsPapers] = useState([]);
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [data, setData] = useState([]);
  const [user,setUser]=useState(-1);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const year = new Date(selectedYear).getFullYear() % 100;
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");

  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewsPapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async (page) => {
    setLoader(true);
    try {
      let res = await API({
        url: "/buildup/getBuildupData",
        method: "POST",
        responseType: "json",
        data: {
          year: selectedYear,
          newspaper: selectedNewspaper,
          search: search,
          type:selectedType,
          page: page,
          limit: config.PER_PAGE,
        },
      });
      if (res.code === 200) {
        setData(res.data[0]?.paginatedRecords);  
        setUser(res.data[0]?.userType);
        setTotalPages(
          Math.ceil(res.data[0]?.totalCount[0]?.count / config.PER_PAGE)
        );
      
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handlePageClick = async (page) => {
    setCurrentPage(page.selected);
    fetchData(page.selected);
  };

  const searchBrand = (e) => {
    setSearch(e.target.value);
  };

  const getMonthData = (data, month) => {
    try {
      return data.filter((record) => record.month === month);
    } catch (error) {
      console.error(error);
    }
  };

  const NewspaperStats = (data, newspaper) => {
    let monthActive = 0;
    let insertions = 0;
    let revenue = 0;
    const year = new Date(selectedYear).getFullYear();
    for (const item of data) {
      if (item.month === 12) {
        if (item[`${newspaper}_insertions_${year - 2}`] > 0) {
          monthActive += 1;
          insertions += item[`${newspaper}_insertions_${year - 2}`];
          revenue += item[`${newspaper}_revenue_${year - 2}`];
        }
      } else {
        if (item[`${newspaper}_insertions_${year - 1}`] > 0) {
          monthActive += 1;
          insertions += item[`${newspaper}_insertions_${year - 1}`];
          revenue += item[`${newspaper}_revenue_${year - 1}`];
        }
      }
    }

    return {
      monthsActive: monthActive,
      insertions: insertions,
      revenue: revenue,
    };
  };

  const financialYearStats = (data) => {
    let insertions = 0;
    let revenue = 0;
    const year = new Date(selectedYear).getFullYear();
    for (const item of data) {
      if (item.month === 12) {
        if (item[`planned_insertions_${year - 1}`] > 0) {
          insertions += item[`planned_insertions_${year - 1}`];
          revenue += item[`planned_revenue_${year - 1}`];
        }
      } else {
        if (item[`planned_insertions_${year}`] > 0) {
          insertions += item[`planned_insertions_${year}`];
          revenue += item[`planned_revenue_${year}`];
        }
      }
    }
    return {
      insertions: insertions,
      revenue: revenue,
    };
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      let res = await API({
        url: "/buildup/downloadBuildupData",
        method: "POST",
        responseType: "json",
        data: {
          year: selectedYear,
          newspaper: selectedNewspaper,
          search: search,
          type:selectedType
        },
      });
      if (res.code === 200) {
        let data = res.data;
        const currentYear = new Date(selectedYear).getFullYear();

        // First header row
        const header1 = [
          "All values are in Lakhs",
          null,
          null,
          null,
          null,
          null,
          ...Array.from({ length: 12 }).flatMap((_, index) => {
            const year = currentYear;
            const month = new Date(year, index, 1).toLocaleString("default", {
              month: "short",
            });
            if (index === 11) {
              return [
                `${month}-${year - 2}`,
                null,
                null,
                null,
                `${month}-${year}`,
                null,
              ];
            }
            return [
              `${month}-${year - 1}`,
              null,
              null,
              null,
              `${month}-${year}`,
              null,
            ];
          }),
          `Dec-${currentYear - 2} to Nov-${currentYear - 1}`,
          null,
          null,
          `Dec-${currentYear - 2} to Nov-${currentYear - 1}`,
          null,
          null,
          `FY${currentYear}`,
          null,
          null,
        ];
        // Second header row
        const header2 = [
          "S.No",
          "Client Name",
          "Category",
          "Sales Person",
          "Client Media Budget",
          "Client Physically Met (Last 3 Months)",
          ...Array.from({ length: 12 }).flatMap(() => [
            selectedNewspaper,
            null,
            "W2N",
            null,
            "W2N",
            null,
          ]),
          "Eenadu",
          null,
          null,
          "W2N",
          null,
          null,
          "W2N",
          null,
          null,
        ];

        // Third header row
        const header3 = [
          "",
          "",
          "",
          "",
          "",
          "",
          ...Array.from({ length: 12 }).flatMap(() => [
            "Insertions",
            "Revenue",
            "Insertions",
            "Revenue",
            "Insertions",
            "Revenue",
          ]),
          "Months Active",
          "Insertions",
          "Revenue",
          "Months Active",
          "Insertions",
          "Revenue",
          "",
          "Insertions",
          "Revenue",
        ];

        // Combine headers into a single array of arrays
        const headers = [header1, header2, header3];
        console.log(headers);
        // Prepare data rows
        let rows = [];
        data.forEach((item, index) => {
          const stats = NewspaperStats(item.month_wise_data, selectedNewspaper);
          const way2Stats = NewspaperStats(item.month_wise_data, "Way2news");
          const fyStats = financialYearStats(item.month_wise_data);
          const row = [
            index + 1,
            item.brand_name,
            item.category,
            item.sales_person,
            item.client_media_budget,
            item.direct_interactions,
            ...Array.from({ length: 12 }).flatMap((_, monthIndex) => {
              const monthData = getMonthData(
                item.month_wise_data,
                monthIndex + 1
              )[0];
              const fyear = new Date(selectedYear).getFullYear();

              if (monthIndex === 11) {
                return [
                  monthData?.[`${selectedNewspaper}_insertions_${fyear - 2}`] ||
                    0,
                  
                    monthData?.[`${selectedNewspaper}_revenue_${fyear - 2}`]
                   || 0,
                  monthData?.[`Way2news_insertions_${fyear - 2}`] || 0,
                  monthData?.[`Way2news_revenue_${fyear - 2}`] || 0,
                  monthData?.[`planned_insertions_${fyear - 1}`] || 0,
                  monthData?.[`planned_revenue_${fyear - 1}`] || 0,
                ];
              } else {
                return [
                  monthData?.[`${selectedNewspaper}_insertions_${fyear - 1}`] ||
                    0,
                 
                    monthData?.[`${selectedNewspaper}_revenue_${fyear - 1}`]
                  || 0,
                  monthData?.[`Way2news_insertions_${fyear - 1}`] || 0,
                  monthData?.[`Way2news_revenue_${fyear - 1}`] || 0,
                  monthData?.[`Way2news_insertions_${fyear}`] || 0,
                  monthData?.[`Way2news_revenue_${fyear}`] || 0,
                ];
              }
            }),
            stats.monthsActive,
            stats.insertions,
            stats.revenue,
            way2Stats.monthsActive,
            way2Stats.insertions,
            way2Stats.revenue,
            "",
            fyStats.insertions,
            fyStats.revenue,
          ];

          rows.push(row);
        });
        const totalsRow = Array(headers[2].length).fill("");
      totalsRow[0] = "G Totals";
      rows[0].forEach((_, colIndex) => {
        if (colIndex > 5) {
          const total = rows.reduce((sum, row) => sum + (row[colIndex] || 0), 0);
          totalsRow[colIndex] = total;
        }
      });

      // Append totals row
      rows.push(totalsRow);

        const worksheetData = [...headers, ...rows];

        // Create worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Merge cells for the first header row
        const merges = [];

        // Merge for the first header row
        merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: 5 } }); // First header merge
        let colIndex = 6;
        for (let i = 0; i < 12; i++) {
          merges.push({
            s: { r: 0, c: colIndex },
            e: { r: 0, c: colIndex + 3 },
          }); // Newspaper Months
          colIndex += 4;
          merges.push({
            s: { r: 0, c: colIndex },
            e: { r: 0, c: colIndex + 1 },
          }); // W2N columns
          colIndex += 2;
        }

        // Additional merges for financial year or summary columns
        merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 2 } });
        colIndex += 3;
        merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 2 } });
        colIndex += 3;
        merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 2 } });

        // Second header row merges
        colIndex = 0;
        for (let i = 0; i < 6; i++) {
          merges.push({ s: { r: 1, c: colIndex }, e: { r: 2, c: colIndex } });
          colIndex += 1;
        }

        for (let i = 0; i < 12; i++) {
          merges.push({
            s: { r: 1, c: colIndex },
            e: { r: 1, c: colIndex + 1 },
          });
          colIndex += 2;
          merges.push({
            s: { r: 1, c: colIndex },
            e: { r: 1, c: colIndex + 1 },
          });
          colIndex += 2;
          merges.push({
            s: { r: 1, c: colIndex },
            e: { r: 1, c: colIndex + 1 },
          });
          colIndex += 2;
        }

        merges.push({ s: { r: 1, c: colIndex }, e: { r: 1, c: colIndex + 2 } });
        colIndex += 3;
        merges.push({ s: { r: 1, c: colIndex }, e: { r: 1, c: colIndex + 2 } });
        colIndex += 3;
        merges.push({ s: { r: 1, c: colIndex }, e: { r: 1, c: colIndex + 2 } });

        // Merges for the third header row (Months Active, Insertions, Revenue)
        worksheet["!merges"] = merges;
        // Merge cells for the third header row (Months Active, Insertions, Revenue)

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          `FY${currentYear} Buildup Sheet`
        );

        // Write the file
        XLSX.writeFile(workbook, `FY ${currentYear} Buildup Sheet.xlsx`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoader(false);
    }
  };

  useEffect(() => {
    fetchNewsPapers();
  }, []);

  useEffect(() => {
    fetchData(0);
    setCurrentPage(0)
  }, [search, selectedNewspaper, selectedYear,selectedType]);

  return (
    <>
      <div className="d-flex gap-3 justify-end items-center my-2">

        <SlSelect  value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value)}}>
                  {user === -1 ? <SlOption value='all'>All</SlOption> : null}
                  {getBrandOptions(user, localStorage.getItem('email'))?.map((type) => (
                    <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
                  ))}
        </SlSelect>
        <SlInput
          type="text"
          placeholder="Search"
          onSlInput={debounce(searchBrand, 500)}
        />
        <SlSelect
          placeholder="NewsPaper"
          value={selectedNewspaper}
          onSlChange={(e) => setSelectedNewspaper(e.target.value)}
        >
          {newsPapers.map((item) => (
            <SlOption key={item.name} value={item.name}>
              {item.name}
            </SlOption>
          ))}
        </SlSelect>
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th colSpan={6}>All values are in Lakhs</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const date = new Date(2024, index, 1);
                return (
                  <>
                    {format(date, "MMM") === "Dec" ? (
                      <th colSpan={4} key={index}>
                        {format(date, "MMM")}-{year - 2}
                      </th>
                    ) : (
                      <th colSpan={4} key={index}>
                        {format(date, "MMM")}-{year - 1}
                      </th>
                    )}
                    <th colSpan={2} key={index}>
                      {format(date, "MMM")}-{year}
                    </th>
                  </>
                );
              })}
              <th colSpan={3}>{`Dec-${year - 2} to Nov-${year - 1}`}</th>
              <th colSpan={3}>{`Dec-${year - 2} to Nov-${year - 1}`}</th>
              <th colSpan={3}>{`FY${year}`}</th>
            </tr>
            <tr>
              <th rowSpan={2}>S.No</th>
              <th rowSpan={2}>Client Name</th>
              <th rowSpan={2}>Category</th>
              <th rowSpan={2}>Sales Person</th>
              <th rowSpan={2}>Client Media Budget</th>
              <th rowSpan={2}>Clinet Physically met in past 3 months</th>
              {Array.from({ length: 12 }).map((_, index) => {
                return (
                  <>
                    <th colSpan={2} rowSpan={1} key={index}>
                      {selectedNewspaper}
                    </th>
                    <th colSpan={2} rowSpan={1}>
                      W2N
                    </th>
                    <th colSpan={2} rowSpan={1} key={index}>
                      W2N
                    </th>
                  </>
                );
              })}
              <th colSpan={3}>Eenadu</th>
              <th colSpan={3}>W2N</th>
              <th colSpan={3}>W2N</th>
            </tr>
            <tr>
              {Array.from({ length: 12 }).map((_, index) => {
                return (
                  <>
                    <th colSpan={1} rowSpan={1} key={index}>
                      Insertions
                    </th>
                    <th colSpan={1} rowSpan={1}>
                      Revenue
                    </th>
                    <th colSpan={1} rowSpan={1} key={index}>
                      Insertions
                    </th>
                    <th colSpan={1} rowSpan={1}>
                      Revenue
                    </th>
                    <th colSpan={1} rowSpan={1} key={index}>
                      Insertions
                    </th>
                    <th colSpan={1} rowSpan={1}>
                      Revenue
                    </th>
                  </>
                );
              })}
              <th>Months Active</th>
              <th>Insertions</th>
              <th>Revenue</th>
              <th>Months Active</th>
              <th>Insertions</th>
              <th>Revenue</th>
              <th></th>
              <th>Insertions</th>
              <th>Revenue</th>
            </tr>
          </thead>
          {!loader && data.length > 0 ? (
            <tbody>
              {data.map((item, index) => {
                const stats = NewspaperStats(
                  item.month_wise_data,
                  selectedNewspaper
                );
                const way2Stats = NewspaperStats(
                  item.month_wise_data,
                  "Way2news"
                );
                const financialStats = financialYearStats(item.month_wise_data);
                return (
                  <tr key={item.brand_id}>
                    <td>{index + 1}</td>
                    <td>{item.brand_name}</td>
                    <td>{item.category}</td>
                    <td>{item.sales_person}</td>
                    <td>{toLakhs(item.client_media_budget)}</td>
                    <td>{item.direct_interactions}</td>
                    {Array.from({ length: 12 }).map((_, index) => {
                      const monthData = getMonthData(
                        item.month_wise_data,
                        index + 1
                      )[0];
                      const fyear = new Date(selectedYear).getFullYear();
                      return index === 12 ? (
                        <>
                          {" "}
                          <td>
                            {
                              monthData?.[
                                `${selectedNewspaper}_insertions_${fyear - 2}`
                              ]
                            }
                          </td>
                          <td>
                            {
                              toLakhs(monthData?.[
                                `${selectedNewspaper}_revenue_${fyear - 2}`
                              ] || 0)
                            }
                          </td>
                          <td>
                            {monthData?.[`Way2news_insertions_${fyear - 2}`]}
                          </td>
                          <td>
                            {toLakhs(monthData?.[`Way2news_revenue_${fyear - 2}`] || 0)}
                          </td>
                          <td>
                            {monthData?.[`planned_insertions_${fyear - 1}`]}
                          </td>
                          <td>{toLakhs(monthData?.[`planned_revenue_${fyear - 1}`] || 0)}</td>
                        </>
                      ) : (
                        <>
                          <td>
                            {
                              monthData?.[
                                `${selectedNewspaper}_insertions_${fyear - 1}`
                              ]
                            }
                          </td>
                          <td>
                            {
                             toLakhs(monthData?.[
                                `${selectedNewspaper}_revenue_${fyear - 1}`
                              ] || 0)
                            }
                          </td>
                          <td>
                            {monthData?.[`Way2news_insertions_${fyear - 1}`]}
                          </td>
                          <td>
                            {toLakhs(monthData?.[`Way2news_revenue_${fyear - 1}`]||0)}
                          </td>
                          <td>{monthData?.[`Way2news_insertions_${fyear}`]}</td>
                          <td>{toLakhs(monthData?.[`Way2news_revenue_${fyear}`] || 0)}</td>
                        </>
                      );
                    })}
                    <td>{stats.monthsActive}</td>
                    <td>{stats.insertions}</td>
                    <td>{toLakhs(stats.revenue)}</td>
                    <td>{way2Stats.monthsActive}</td>
                    <td>{way2Stats.insertions}</td>
                    <td>{toLakhs(way2Stats.revenue)}</td>
                    <td></td>
                    <td>{financialStats.insertions}</td>
                    <td>{financialStats.revenue}</td>
                  </tr>
                );
              })}
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={90} />
          ) : (
            <NoDataFound colspan={90} />
          )}
        </table>
      </ScrollContainer>
      <div className=" right-fixed mt-4">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
    </>
  );
}

export default BuildupSheet;
